import { Rule } from './rule';

export class VideoPokerCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.videopoker.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.videopoker.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.videopoker.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-2c' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-2d' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-2e' },
      ],
    },
    {
      title: 'components.cheat-sheet.videopoker.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-3c' },
      ],
    },
    {
      title: 'components.cheat-sheet.videopoker.header-4',
      body: [{ type: 'text', content: 'components.cheat-sheet.videopoker.body-4a' }],
    },
    {
      title: 'components.cheat-sheet.videopoker.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-5b' },
      ],
    },
    {
      title: 'components.cheat-sheet.videopoker.header-6',
      body: [
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-6a' },
        { type: 'text', content: 'components.cheat-sheet.videopoker.body-6b' },
      ],
    },
  ];
}
